(ns app.front.view.admin.integration-messages
  (:require [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx
  ::reset
  (fn [_ _]
    {:comm/command {:command    :admin/get-authority-groups
                    :method     :get
                    :data       {:with-integration true}
                    :on-success [::customers-response]}}))


(rf/reg-event-fx
  ::fetch-data
  (fn [_ [_ {:keys [group-id from until]}]]
    {:comm/command {:command    :admin/get-integration-messages
                    :method     :get
                    :data       {:authority-group-id group-id
                                 :from               from
                                 :until              until}
                    :on-success [::fetch-success]}}))

(rf/reg-event-db
  ::fetch-success
  (fn [db [_ _ data]]
    (assoc db ::messages data)))

(rf/reg-sub ::messages #(-> % ::messages))


(rf/reg-event-db
  ::customers-response
  (fn [db [_ _ data]]
    (->> data
         (map (juxt :group/id :group/name))
         (into {})
         (assoc db ::customers))))

(rf/reg-sub ::customers (p/fn->> ::customers (sort-by first)))

(defn message-viewer [message]
  [:div.integration-message {:key (:db/id message)}
   (for [[k v] message]
     [:div.integration-message__row.bx--row {:key (str (:db/id message) k)}
      [:div.bx--col-xs-6.bx--col-md-4.bx--col-lg-3.bx--col-xl-2
       (str k)]
      [:div.integration-message__value.bx--col-xs-6.bx--col-md-8.bx--col-lg-9.bx--col-xl-10
       (if (inst? v)
         (.toISOString v)
         (str v))]])])


(defn view [_]
  (let [tr       (<sub [:tr])
        start    (date-util/date-add -7)
        end      (date-util/date-add 1)
        end-str  (.format date-util/calendar-date-format end)
        arg-atom (r/atom {:from     (.-date ^js start)
                          :until    (js/Date.)
                          :group-id ""})]
    (fn [_]
      [:div.cloudpermit-page.admin-page
       [:div.bx--row.page-heading
        [:h1.bx--col-xs-12 (tr [:admin-tools/integration-messages])]]
       [:section.flex.flex-wrap.items-end
        [:div.mr-3.mt-3
         [ui/date-picker {:id         "integration-message-date-picker-1"
                          :label-text (tr [:admin-tools/from])
                          :min-date   "2019-01-01"
                          :max-date   end-str
                          :value      (:from @arg-atom)
                          :class-name "admin-date-picker"
                          :callback   (fn [from]
                                        (swap! arg-atom assoc :from (date-util/start-of-day from)))}]]
        [:div.mr-3.mt-3
         [ui/date-picker {:id         "integration-message-date-picker-2"
                          :label-text (tr [:admin-tools/until])
                          :min-date   "2019-01-01"
                          :max-date   end-str
                          :value      (:until @arg-atom)
                          :class-name "admin-date-picker"
                          :callback   (fn [until]
                                        (swap! arg-atom assoc :until (date-util/end-of-day until)))}]]
        [:div.mr-3.mt-3
         (into
           (cc/select
             {:id            "integration-message-group-id"
              :default-value :none
              :label-text    (tr [:customer-id])
              :on-change     #(swap! arg-atom assoc :group-id (-> % .-target .-value))}
             [ui/placeholder-select-item tr]
             (for-frag [[group-id group-name] (<sub [::customers])]
               (cc/select-item {:text  (str group-id ": " group-name)
                                :value group-id}))))]
        [:div.mt-3
         (cc/button
           {:kind     :primary
            :disabled (str/blank? (:group-id @arg-atom))
            :on-click #(>evt [::fetch-data @arg-atom])}
           (tr [:admin-tools/retrieve-messages]))]]
       (let [messages (<sub [::messages])]
         (into
           [:section.admin__integration-messages
            (cond
              (seq messages)
              [:div
               (tr [:admin-tools/msg-from])
               (.toString (:from @arg-atom))
               (tr [:admin-tools/msg-to])
               (.toString (:until @arg-atom))]

              (some? messages)
              [:div
               (tr [:admin-tools/no-msg-from])
               (.toString (:from @arg-atom))
               (tr [:admin-tools/msg-to])
               (.toString (:until @arg-atom))]

              :else
              [:div (tr [:admin-tools/msg-not-retrieved])])]

           (for [message (<sub [::messages])]
             [message-viewer message])))])))

(def route
  {:name        :view/admin.integration-messages
   :view        view
   :controllers [{:start (fn [] (>evt [::reset]))}]})
